export default "/images/module_icons_w_bg_color.png?ed09d6ccb09b69dae77df93c8c30165e";